import {uniq, nthArg, range, moment, createSelector} from 'vendor';
import {today, date} from 'store/common';

export const startOfWeek = createSelector(
  [ date, today ],
  ( date, today ) => (date || today).clone().startOf('week').unix(),
  { memoizeOptions: { maxSize: 50 } },
);

export const week = createSelector(
  [ startOfWeek ],
  ( startOfWeek ) => range(7).map(i => moment.unix(startOfWeek + i*24*60*60)),
  { memoizeOptions: { maxSize: 50 } },
);

export const lastWeeks = createSelector(
  [ nthArg(0), nthArg(1) ],
  ( state, period ) => uniq(period.map(date => week(state, { date }))),
  { memoizeOptions: { maxSize: 50 } },
);
